import { SET_APP_SECTION } from '../actions/types';

const initialState = {
  section: 'live',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_APP_SECTION:
      return {
        ...state,
        section: action.payload,
      };
    default:
      return state;
  }
}
